var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPark1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4813 0.370117H3.2587C1.96211 0.370117 0.910156 1.35632 0.910156 2.57188V18.7181C0.910156 19.9337 1.96211 20.9199 3.2587 20.9199H20.4813C21.7779 20.9199 22.8299 19.9337 22.8299 18.7181V2.57188C22.8299 1.35632 21.7779 0.370117 20.4813 0.370117ZM12.6529 13.5807H10.3043V15.7824C10.3043 16.1861 9.95204 16.5163 9.52148 16.5163H7.95578C7.52522 16.5163 7.17294 16.1861 7.17294 15.7824V5.50755C7.17294 5.1039 7.52522 4.77363 7.95578 4.77363H12.6529C15.2412 4.77363 17.35 6.75063 17.35 9.17715C17.35 11.6037 15.2412 13.5807 12.6529 13.5807ZM12.6529 7.70931H10.3043V10.645H12.6529C13.514 10.645 14.2186 9.98446 14.2186 9.17715C14.2186 8.36984 13.514 7.70931 12.6529 7.70931Z",
    fill: "url(#paint0_linear_747_37464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_747_37464",
    x1: 22.8299,
    y1: 20.9199,
    x2: -0.909456,
    y2: 18.5429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark1);
export default __webpack_public_path__ + "static/media/park1.08e07a40a9952595ceade06b4e7625a9.svg";
export { ForwardRef as ReactComponent };